export default [
    {
        path: "/appeals/my-appeals",
        name: "my-appeals",
        meta: { title: "my-appeals", authRequired: true, privileges: ['SUPPLIER_VIEW_APPEALS'] },
        component: () => import("../views/appeals/my-appeals.vue"),
    },
    {
        path: "/appeals/create-appeal",
        name: "create-appeal",
        meta: { title: "create-appeal", authRequired: true, privileges: ['SUPPLIER_SUBMIT_APPEALS'] },
        component: () => import("../views/appeals/create-appeal.vue"),
    }
]
